export default function BloodDonationData() {
  window.location.href = 'https://www.kanver.org/KanHizmetleri/KanBagisiNoktalari';
  return (
    <h2>
      <b>kanver.org</b>
      'a yönlendiriliyorsunuz...
    </h2>
  );
}
